module.exports = __webpack_public_path__ + "static/media/cuentas.83f038be.svg";